import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BuyBalanceService} from '../../../service/buy-balance.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import {Billingservices} from '../../../model/Billingservices';
import {AuthService} from '../../../service/auth/auth.service';
import {Enterprise} from '../../../model/Enterprise';
import {Partner} from '../../../model/Partner';
import {Router} from '@angular/router';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-billing-service',
  templateUrl: './billing-services.component.html',
  styleUrls: ['./billing-services.component.css']
})
export class BillingServicesComponent implements OnInit {

  public billingservices: Billingservices[];
  public loading: boolean;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public enterprises: Enterprise[] = [];
  public partners: Partner[] = [];
  public partnerIdSelected = 1;
  public enterpriseIdSelected = 1;
  public enterpriseSelected: Enterprise;
  public partnerSelected: Partner;
  private interval: any;

  constructor(private buyBalanceService: BuyBalanceService,
              private authenticationService: AuthService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private router: Router) {

  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  private loadDefaultData(): void {
    this.loadBillingServices();
  }

  ngOnInit(): void {
    this.setDefaultData();
    this.beginAutorefreh();
  }

  private beginAutorefreh() {
    this.interval = setInterval(() => {
      this.loadBillingServices();
    }, 30000);
  }

  public createBillingServices() {
    this.router.navigate(['create-billing']).then();
  }

  public reloadBillingServices() {
    this.getEnterprisesByPartner(this.partnerSelected.id);
  }

  public reloadBillingServices0() {
    if (this.enterpriseSelected) {
      this.enterpriseIdSelected = this.enterpriseSelected.id;
    }
    this.loadBillingServices();
  }

  private setDefaultData() {
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartnersExtra();
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
      this.loadDefaultData();
    }
  }

  public loadBillingServices(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1 + '/enterprise/' + String(this.enterpriseIdSelected) + '/billingservices';
    this.buyBalanceService.get(url).subscribe((value: any) => {
      this.loading = false;
      if (value.length > 0) {
        this.billingservices = value;
      } else {
        this.billingservices = [];
      }
    }, () => {
      this.loading = false;
    });
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      this.enterprises = LocalStorage.addEnterprise(enterprises).sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.enterpriseDataService.setEnterprises(this.enterprises);
      this.loadDefaultData();
    });
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.enterpriseDataService.setEnterprises(this.enterprises);
      this.loadDefaultData();
    });
  }
}
